import { render } from "./rbqmInteligentDashboard.vue?vue&type=template&id=bdf2a346&scoped=true"
import script from "./rbqmInteligentDashboard.js?vue&type=script&lang=js"
export * from "./rbqmInteligentDashboard.js?vue&type=script&lang=js"

import "./rbqmInteligentDashboard.vue?vue&type=style&index=0&id=bdf2a346&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdf2a346"]])

export default __exports__